import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wrapper"
};
const _hoisted_2 = {
  class: "wrapper-container wrapper-container-left"
};
const _hoisted_3 = {
  class: "wrapper-container-box menus"
};
const _hoisted_4 = {
  class: "wrapper-container-item"
};
const _hoisted_5 = {
  class: "tab-bar-item-box"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "tab-title"
};
const _hoisted_8 = {
  class: "wrapper-container-box notice"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "wrapper-container wrapper-container-right"
};
const _hoisted_11 = {
  class: "wrapper-container-box todo"
};
import Todo from "./components/Todo";
import BoardTitle from "./components/BoardTitle";
import NoticeInfo from "./components/NoticeInfo";
import ResetPwd from "./components/ResetPwd.vue";
import Notice from "./components/Notice";
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import apis from "@/api";
import { useStore } from "vuex";
export default {
  __name: 'HomeBoard',
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const data = reactive({
      noticeList: [],
      quickList: [],
      dialogFormVisible: false,
      resetPwdVisible: false,
      currentNotice: {}
    });
    const goQuick = quick => {
      router.push({
        name: quick.url
      });
    };
    const initQuickList = () => {
      apis.getQuickList().then(res => {
        if (res.success) {
          for (let dataKey of res.data) {
            dataKey.icon = dataKey.icon.replace('http://10.174.80.86:7000/', 'http://36.137.21.64:7000/');
          }
          data.quickList = res.data;
        } else {
          ElMessage.error("常用功能获取异常");
        }
      });
    };
    //查询最新公告
    const loadLatestNotice = () => {
      apis.listValid().then(res => {
        if (res.success) {
          data.noticeList = res.data;
        } else {
          ElMessage.error("公告查询异常");
        }
      });
    };
    const showDetail = notice => {
      console.log("notice:", notice);
      data.currentNotice = notice;
      data.dialogFormVisible = true;
    };
    // 检查是否需要重设密码
    const checkDefaultPwd = () => {
      const userInfo = store.state.userInfo;
      if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.isDefaultPwd) === '1') {
        data.resetPwdVisible = true;
      }
    };
    onMounted(() => {
      initQuickList();
      loadLatestNotice();
      checkDefaultPwd();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(BoardTitle), {
        title: "常用功能"
      }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_row, {
        class: "tab-bar",
        gutter: 20
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.quickList, (item, index) => {
          return _openBlock(), _createBlock(_component_el_col, {
            class: "tab-bar-item",
            span: 4,
            key: index,
            onClick: $event => goQuick(item)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              src: item.icon
            }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)]),
            _: 2
          }, 1032, ["onClick"]);
        }), 128))]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(BoardTitle), {
        title: "系统公告"
      }), _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_el_card, null, {
          default: _withCtx(() => [data.noticeList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.noticeList, notice => {
            return _openBlock(), _createBlock(_unref(Notice), {
              key: notice.id,
              notice: notice,
              onNoticeClick: $event => showDetail(notice)
            }, null, 8, ["notice", "onNoticeClick"]);
          }), 128))])) : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无公告"
          }))]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(BoardTitle), {
        title: "待办事项",
        more: "/#/todo"
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Todo))]),
        _: 1
      })])]), _createVNode(_component_el_dialog, {
        modelValue: data.dialogFormVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.dialogFormVisible = $event),
        top: "5%",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createVNode(_unref(NoticeInfo), {
          notice: data.currentNotice
        }, null, 8, ["notice"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        title: "请修改初始密码",
        modelValue: data.resetPwdVisible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.resetPwdVisible = $event),
        style: {
          "width": "40%"
        },
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      }, {
        default: _withCtx(() => [_createVNode(ResetPwd, {
          onSuccess: _cache[1] || (_cache[1] = $event => data.resetPwdVisible = false)
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};